import { Breadcrumb, Input, Select, Tree } from "antd"
import Layout from "../../../../Layout"
import { useEffect, useState } from "react"
import { avatarDefault } from "../../../../components/ExportImgFigma"
import { CaretDownOutlined, PlusCircleFilled } from "@ant-design/icons"
import { editUserAccount, getInfoAccount, IAccountDetail } from "../../../../api/groupPermission/groupPermissionApi"
import { useSelector } from "react-redux"
import { selectorInfoUser, setInfoUser } from "../../../../store/slices/infoUserSlice"
import useToast from "../../../../hook/useToast"
import { URL_AVATAR } from "../../../../env"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { findChildIdByUrl } from "../../../../until"
import { selectorMenu } from "../../../../store/slices/menuSlice"
import * as fomartUnit from "../../../../services/fomartUnit"
import * as SelectOptionApi from "../../../../api/selectOptions/selectOptionsApi"
import *as unitApi from "../../../../api/unit/unitApi"

const InforAccount: React.FC = () => {
  const pushToast = useToast()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const menuSlice = useSelector(selectorMenu)
  const { id, username, image, unit, groupPermission, role, unitTemp } = useSelector(selectorInfoUser)
  const { add, download, edit, upload, delete: isdelete, share } = findChildIdByUrl(menuSlice, "/customer/list")
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)
  const [avatar, setAvatar] = useState<File | null>(null);
  const [name, setName] = useState<string | undefined>("")
  const [infoAccount, setInfoAccount] = useState<IAccountDetail>()
  const [dataListNationwide, setDataListNationwide] = useState<fomartUnit.OptionSelect_V2[]>([])
  const [valuesTagUnit, setValuesTagUnit] = useState<number[]>([]);

  let unitTitle = share ? "VPĐH THACO AUTO" : (infoAccount?.unit?.title + " (" + infoAccount?.unit?.code + ")")

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      setPreviewUrl(URL.createObjectURL(file))
      setAvatar?.(file)
    }
  }
  const gInfoAccount = async () => {
    const result = await getInfoAccount(id)
    if (result?.status) {
      setInfoAccount(result.data)
      setName(result?.data?.fullname)
      setPreviewUrl(`${URL_AVATAR}${result?.data?.image}`)
      dispatch(setInfoUser(convertDataUser(result.data)));
    } else {
      pushToast(result?.message, "warning")
    }
  }
  const convertDataUser = (data: IAccountDetail) => ({
    id: data.id,
    image: data.image,
    unit: unit,
    username: data.fullname,
    groupPermission: groupPermission,
    role: role,
    unitTemp: unitTemp
  });
  const editInforAccount = async () => {
    const result = await editUserAccount(id, name, avatar)

    if (result?.status) {
      pushToast(result?.message, "success")
      gInfoAccount()

    } else {
      pushToast(result?.message, "warning")
    }
  }

  const gListNationwide = async () => {
    const result = await SelectOptionApi.getListNationwide();

    if (result?.status) {
      setDataListNationwide(unitApi.convertNationwideTree(result.data))
    } else {
      console.log('object');
    }
  }
  useEffect(() => {
    if (dataListNationwide.length === 0) {
      gListNationwide()
    }
  }, [dataListNationwide])

  useEffect(() => {
    if (id) {
      gInfoAccount()



    } else {
      navigate(-1)
    }
  }, [id])

  useEffect(() => {
    const listTagUnitTmg = infoAccount?.unitsByPermissionGroup
      ?.flatMap((item) => item.units.map((children) => children?.id))

    setValuesTagUnit(listTagUnitTmg || [])
  }, [infoAccount])

  return (
    <Layout>
      <Breadcrumb
        items={[
          {
            title: 'THACO AUTO CRM',
          },
          {
            title: <a href="/">Cấu hình</a>,
          },
          {
            title: 'Cấu hình chung',
          },
        ]}
      />
      <div className='title-page'>
        Thông tin tài khoản
      </div>
      <div className=" h-full d-flex flex-column justify-between">
        <div className="d-flex gap-6 ">
          <div className={`upload-image  ${!previewUrl ? 'h-100-px' : 'h-fit-content'}`}>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
            {
              previewUrl
                ? (
                  <div className="w-100-px">
                    <img
                      src={previewUrl}
                      alt="Preview"
                      onError={(e) => {
                        e.currentTarget.src = avatarDefault;
                      }}
                      className="img-account"
                    />
                    <span className="upload-image__preview-icon">
                      <PlusCircleFilled />
                    </span>
                  </div>
                )
                : (
                  <div className="w-100-px">
                    <img
                      src={avatarDefault}
                      alt="Preview"
                      className="img-account"
                    />
                    <span className="upload-image__preview-icon">
                      <PlusCircleFilled />
                    </span>
                  </div>
                )
            }
          </div>
          <div className="d-flex flex-column gap-4 w-full">
            <span className="text-sm font-bold fw-700">Thông tin cơ bản</span>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex gap-6">
                <span className="w-120-px text-sm fw-500 font-medium"> Mã nhân viên </span>
                <span className=" text-sm fw-400 font-regular">{infoAccount?.code}</span>
              </div>
              <div className="d-flex gap-6">
                <span className="w-120-px text-sm fw-500 font-medium"> Tên đăng nhập </span>
                <span className=" text-sm fw-400 font-regular">{infoAccount?.username}</span>
              </div>
              <div className="d-flex gap-6">
                <span className="w-120-px text-sm fw-500 font-medium">Họ và tên </span>
                <Input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Họ và tên"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8 w-352-px"
                />
              </div>
            </div>
            <span className="text-sm font-bold fw-700">Quyền và nhóm quyền</span>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex gap-6">
                <span className="w-120-px text-sm fw-500 font-medium"> Toàn quốc </span>
                <span className=" text-sm fw-400 font-regular">{infoAccount?.nationwide}</span>
              </div>
              <div className="d-flex gap-6">
                <span className="w-120-px text-sm fw-500 font-medium"> Đơn vị </span>
                <span className=" text-sm fw-400 font-regular">{unitTitle}</span>
              </div>
              <div className="d-flex gap-6">
                <span className="w-120-px text-sm fw-500 font-medium"> Khối nghiệp vụ </span>
                <span className=" text-sm fw-400 font-regular">{infoAccount?.businessUnit}</span>
              </div>
              <div className="d-flex gap-6">
                <span className="w-120-px text-sm fw-500 font-medium"> Phòng ban </span>
                <span className=" text-sm fw-400 font-regular">{infoAccount?.department}</span>
              </div><div className="d-flex gap-6">
                <span className="w-120-px text-sm fw-500 font-medium"> Nhóm quyền </span>
                <span className=" text-sm fw-400 font-regular">{infoAccount?.groupPermission}</span>
              </div>
            </div>
            <p className="text-sm fw-700 font-bold text-344054 py-5">Phạm vi áp dụng</p>
            <div className="d-flex justify-between align-center">
              <Tree
                checkable
                showLine={true}
                checkedKeys={valuesTagUnit}
                treeData={unitApi.convertNationwideTreeV2(infoAccount?.permissionGroupsByUnit || [])}

                switcherIcon={<CaretDownOutlined className=' text-8E8E8E' />}
                className="custom-ant-tree"
              />
            </div>

          </div>
        </div>
        <div className="w-full d-flex justify-end gap-2 py-4">
          <div className="d-flex gap-2">
            <button className="border-D9D9D9 bg-white h-8 w-57-px rounded-6-px">
              Hủy
            </button>
            <button className="border-none bg-white h-8 w-109-px bg-1890FF rounded-6-px text-white" onClick={editInforAccount}>
              Lưu thay đổi
            </button>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default InforAccount
